import PropTypes from "prop-types";
import { useCallback } from "react";

import { apiClient } from "@/features/shared";
import { CustomAsyncAutocomplete } from "@/features/ui";

export const CustomerSelect = ({ ...props }) => {
  const fetchCustomers = useCallback(async (searchValue, { page, size } = {}) => {
    const {
      data: { data },
    } = await apiClient.get("customers", {
      params: {
        page,
        size,
        search: searchValue,
      },
    });
    return data;
  }, []);

  return (
    <CustomAsyncAutocomplete
      fetchOptions={fetchCustomers}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      renderOption={(props, option) => {
        const { id, name, email, phoneNumbers } = option;

        const values = [
          email,
          ...phoneNumbers.map(
            ({ dialCode, number }) => `+${dialCode}${number}`
          ),
        ].filter(Boolean);

        return (
          <li {...props} key={id}>
            <div>
              <div>{name}</div>
              <div style={{ fontSize: "0.75rem" }}>{values.join(", ")}</div>
            </div>
          </li>
        );
      }}
      {...props}
      TextFieldProps={{
        ...props?.TextFieldProps,
        InputProps: {
          ...(props.TextFieldProps?.InputProps || {}),
          placeholder:
            props.TextFieldProps?.InputProps?.placeholder ||
            "Cari nama/email/No. HP",
        },
      }}
    />
  );
};

CustomerSelect.propTypes = {
  TextFieldProps: PropTypes.object,
};
